<template>
    <div class="container-create-contract-signing-flow scroll-color" @keydown="closeWithEsc">
        <span class="close-contract-flow" @click="close"><em class="fal fa-times" /></span>

        <div class="create-contract-signing-flow">
            <section class="contract-flow-left">
                <span class="title-contract-flow-left">Criar Fluxo de Assinatura de Contrato</span>

                <div class="flow-chain-menu">
                    <ui-chain-menu-3 v-model="steps" clickable />
                </div>

                <div class="image-docu-sign">
                    <img :src="docuSignImg" alt="docu-sign" />
                </div>
            </section>

            <div v-show="loading" class="loader-signers">
                <ui-load-indicator :h="50" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
            </div>

            <div v-show="!loading" class="container-contract">
                <ui-contract-form-flow-config
                    v-if="currentStep === 'configs'"
                    @next="nextHandler('configs')"
                />

                <ui-contract-form-flow-select-signers
                    v-else-if="currentStep === 'signers'"
                    @next="nextHandler('signers')"
                    @close="close"
                />
            </div>
        </div>

        <ui-add-signers-modal />
    </div>
</template>

<script>
    import { uiChainMenu3 } from '@/components/ui/menus'
    import uiContractFormFlowConfig from './components/contract-form-flow-config'
    import uiContractFormFlowSelectSigners from './components/contract-form-flow-select-signers'
    import { uiAddSignersModal } from '@/components/ui-facilita/products'
    import { uiLoadIndicator } from '@/components/ui'

    import { mapGetters } from 'vuex'

	export default {
		name: 'ui-docu-sign-contract-sign-flow',

		components: {
            uiChainMenu3,
            uiContractFormFlowConfig,
            uiContractFormFlowSelectSigners,
            uiAddSignersModal,
            uiLoadIndicator
		},

        data() {
            return {
                steps: [
                    {
                        name: 'Configurações',
                        slug: 'configs',
                        active: true,
                        completed: false
                    },
                    {
                        name: 'Selecionar Assinantes',
                        slug: 'signers',
                        active: false,
                        completed: false
                    }
                ]
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                envelope: 'getEnvelope',
                loading: 'getLoading'
            }),
            /**
             * Retorna a imagem com a logo da integração DocuSign
             */
            docuSignImg() {
                return require('@/assets/imgs/docu-sign-simbolo.png')
            },
            /**
             * Computed property que define qual etapa está ativa
             */
            currentStep() {
                return this.steps.find(step => step.active)?.slug
            }
        },

        // beforeDestroy() {
        //     document.querySelector('.header-open-search').style.display = 'flex'
        // },

        // mounted() {
        //     document.querySelector('.header-open-search').style.display = 'none'
        // },

        methods: {
            /**
             * Solicita o fechamento do modal de configuração
             */
            close() {
                const event = new CustomEvent('iframe--request-modal')
				window.parent.document.dispatchEvent(event)
            },
            /**
             * Event handler que trata o evento de quando uma etapa do cadastro do fluxo
             * é selecionada ou completada
             */
            stepHandler(slug, active, completed=null) {
                const index = this.steps.findIndex(step => step.slug === slug)
                if (index >= 0) {
                    this.steps[index].active = active
                    if (typeof completed === 'boolean') this.steps[index].completed = completed
                }
            },
            /**
             * Event handler que trata o evento de quando a próxima etapa da configuração
             * é requerida
             */
            nextHandler(event) {
                switch (event) {
                    case 'configs':
                        if (this.envelope) {
                            this.stepHandler('configs', false, true)
                            this.stepHandler('signers', true)

                        } else {
                            this.$toastr.e('Falha ao avançar! Nenhuma informação de fluxo foi cadastrada.')
                        }
                        break

                    case 'signers':
                        if (this.signers?.length) {
                            this.stepHandler('signers', true, true)
                            this.close()

                        } else {
                            this.$toastr.e('Falha ao finalizar! Nenhuma configuração de assinante foi definida.')
                        }
                        break
                }
            },
            /**
             * Event handler que trata o evento para fechar o modal com a tecla esc
             */
            closeWithEsc(event) {
                if (event.keyCode === 27) {
                    this.close()
                }
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>